import React, { FC } from 'react';
import { Dialog, DialogTitle, List, ListItem, ListItemAvatar, ListItemText, Avatar, IconButton, Typography } from '@material-ui/core';
import { AllInbox, Build, Close } from '@material-ui/icons';

interface DeviceOverviewDialogProps {
  open: boolean;
  onClose: (value: string) => void;
  offlineOpen: boolean;
}

const DeviceOverviewDialog: FC<DeviceOverviewDialogProps> = ({ onClose, open, offlineOpen }) => {
  const handleListItemClick = (value: string) => {
    onClose(value);
  };

  return (
    <Dialog onClose={() => ("")} aria-labelledby="device-overview-dialog-title" open={open}>
      <IconButton
          aria-label="close"
          onClick={() => onClose('close')}
          style={{ position: 'absolute', right: 8, top: 8 }}
        >
          <Close />
        </IconButton>
      <DialogTitle id="device-overview-dialog-title" style={{ marginRight: '31px' }}>Vælg handling</DialogTitle>
      <List>
        <ListItem autoFocus button onClick={() => handleListItemClick('log')}>
          <ListItemAvatar>
            <Avatar>
              <AllInbox />
            </Avatar>
          </ListItemAvatar>
          <ListItemText primary="Hændelseslog" />
        </ListItem>
        {!offlineOpen && (
          <ListItem autoFocus button onClick={() => handleListItemClick('manage')}>
            <ListItemAvatar>
              <Avatar>
                <Build />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary="Administrer" />
          </ListItem>
        )}
      </List>
    </Dialog>
  );
};

export default DeviceOverviewDialog;